module.exports = __webpack_public_path__ + "assets/img/VW.422abaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/VW.png
// module id = jryC
// module chunks = 1